<template>
  <b-media no-body class="chat-message">
    <template v-if="type === 'message'">
      <b-media-aside>
        <b-img :src="author.avatar" :alt="author.fullname" :width="35" :height="35" rounded="circle" class="mr-3" />
      </b-media-aside>
      <b-media-body>
        <div class="d-flex">
          <h6 class="flex-grow-1 author"><strong>{{ author.fullname }}</strong></h6>
          <p class="date" :key="timestamp">
            {{ date | small }}
            <!-- <font-awesome-icon :icon="['far', 'clock']" /> -->
          </p>
        </div>
        <p class="message" v-html="wrapEmoji(message.text)" />
      </b-media-body>
    </template>
    <template v-else-if="type === 'join'">
      <b-media-body class="system">
        <div class="d-flex">
          <p class="flex-grow-1 message">К нам присоединился {{ author.fullname }}</p>
          <p class="date" :key="timestamp">
            {{ date | small }}
            <!-- <font-awesome-icon :icon="['far', 'clock']" /> -->
          </p>
        </div>
      </b-media-body>
    </template>
    <template v-else-if="type === 'disconnect'">
      <b-media-body class="system">
        <div class="d-flex">
          <p class="flex-grow-1 message">{{ author.fullname }} вышел из чата</p>
          <p class="date" :key="timestamp">
            {{ date | small }}
            <!-- <font-awesome-icon :icon="['far', 'clock']" /> -->
          </p>
        </div>
      </b-media-body>
    </template>
  </b-media>
</template>

<script>
import { small } from '@/filters/date'
import { EmojiIndex } from 'emoji-mart-vue-fast'
import emojiRegex from 'emoji-regex'
import dataEmoji from 'emoji-mart-vue-fast/data/apple'

import 'emoji-mart-vue-fast/css/emoji-mart.css'

let exclude = ['flags']

let emojiIndex = new EmojiIndex(dataEmoji, {
  exclude
})

const unicodeEmojiRegex = emojiRegex()

function wrapEmoji (text) {
  const length = text.length
  return text.replace(unicodeEmojiRegex, function (match, offset) {
    const before = text.substring(0, offset)
    // We add "data-text='{emoji.native}'", don't replace it
    if (before.endsWith('alt="') || before.endsWith('data-text="')) {
      return match
    }
    let emoji = emojiIndex.nativeEmoji(match)
    if (!emoji) {
      // Can't find unicode emoji in our index
      return match
    }
    // See `emojiToHtml` function above.
    return emojiToHtml(emoji, length === match.length)
  })
}
function emojiToHtml (emoji, single) {
  single = !!single
  let style = `background-position: ${emoji.getPosition()};`
  if (single) {
    style += ' width: 48px; height: 48px;'
  } else {
    style += ' width: 1.5rem; height: 1.5rem;'
  }
  return `<img data-text="${emoji.native}" alt="${emoji.colons}" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" class='emoji-text emoji-set-apple emoji-type-image' style="${style}">`
}

export default {
  filters: {
    small
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    message: {
      type: Object,
      required: true
    },
    date: {
      type: String,
      required: true
    }
  },
  data: () => ({
    timestamp: (new Date()).getTime()
  }),
  computed: {
    author () {
      return this.user
    }
  },
  beforeMount () {
    this.readMessage()
  },
  mounted () {
    this.updateDate()
  },
  methods: {
    wrapEmoji,
    readMessage () {
      if (this.type !== 'message') {
        return
      }
      if (!this.message.unread) {
        return
      }

      this.$store.dispatch('ChatModule/read', this.message)
    },
    updateDate () {
      this.timestamp = (new Date()).getTime()
      setTimeout(this.updateDate, 30000)
    }
  }
}
</script>

<style lang="scss">
.chat-message {
  .system {
    font-size: .8rem;
    color: rgb(100,100,100);
    p.message {
      font-family: Arial;
      font-style: italic;
    }
    p.date {
      font-size: .75rem;
      color: rgb(180,180,180);
    }
  }
  .message {
    white-space: pre-line;
    word-break: break-all;
  }
  h6.author {
    margin: 0;
    padding: 0;
    line-height: 1rem;
  }
  p {
    margin-bottom: .1rem;
  }
  p.date {
    font-size: .75rem;
    color: rgb(180,180,180);
    // font-variant: all-small-caps;

    svg {
      font-size: 1rem;
    }
  }
}
</style>
